<template>
  <div class="container">
    <van-nav-bar title="配置计费规则" left-text="" left-arrow @click-left="onClickLeft"></van-nav-bar>
    <div class="loading" v-if="loading">

    </div>
    <div class="main" v-if="!loading">
      <div class="topmsg">
        <div v-if="ruleDetail.isSuccess">
          <van-icon color="#67C23A" size="30" name="checked" />
          <span>计费规则配置成功！</span>
        </div>
        <div v-else>
          <van-icon color="#FF7677" size="30" name="clear" />
          <span>计费规则配置失败！</span>
        </div>
      </div>
      <div class="mg12 col_r texc" v-if="!ruleDetail.isSuccess">提醒：{{ruleDetail.remark}}</div>
      <div class="mg12">
        <van-field center readonly label-width="200" label="平台下发收费标准：" placeholder="" />
      </div>
      <div class="listbox">
        <van-row>
          <van-col span="6">收费标准</van-col>
          <van-col span="6">功率范围</van-col>
          <van-col span="6">收费标准</van-col>
          <van-col span="6">功率范围</van-col>
        </van-row>
        <van-row >
          <span :key="index" v-for="(item,index) in downRuleList">
            <van-col span="6">{{(60 / item.price).toFixed(2)}}元/小时</van-col>
            <van-col span="6">{{item.pMin}}W~{{item.pMax}}W</van-col>
          </span>
        </van-row>
      </div>

      <div class="mg12">
        <van-field center readonly label-width="200" label="设备上报收费标准：" placeholder="" />
      </div>
      <div class="listbox">
        <van-row>
          <van-col span="6">收费标准</van-col>
          <van-col span="6">功率范围</van-col>
          <van-col span="6">收费标准</van-col>
          <van-col span="6">功率范围</van-col>
        </van-row>
        <van-row>
          <span :key="index" v-for="(item,index) in upRuleList">
            <van-col span="6">{{(60 / item.price).toFixed(2)}}元/小时</van-col>
            <van-col span="6">{{item.pMin}}W~{{item.pMax}}W</van-col>
          </span>
        </van-row>
      </div>
      <div class="btnbox">
        <van-button v-if="ruleDetail.isSuccess" type="info" size="large" @click="complateActive">完成激活</van-button>
        <van-button v-if="!ruleDetail.isSuccess" class="bg_r" type="warning" size="large" @click="getRuleInfo">重新获取计费规则</van-button>
      </div>
    </div>

  </div>
</template>

<script>
  import axios from '@/axios.js';
  import {NavBar,Icon,Image,Toast,Button,Field,Col,Row,Uploader} from 'vant';
  export default {
    data() {
      return {
        communityName: '',
        communityId: '',
        location:'',
        ruleDetail:{},
        downRuleList:[],
        upRuleList:[],
        loading:true,
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Image.name]:Image,
      [Toast.name]:Toast, 
      [Button.name]:Button,
      [Field.name]:Field,
      [Col.name]:Col,
      [Row.name]:Row,
      [Uploader.name]:Uploader,
    },
    methods: {
      changePage(url){
        this.$router.push({path: url+".html"});
      },
      getRuleInfo() {
        Toast.loading({
          duration: 0,       // 持续展示 toast
          forbidClick: true, // 禁用背景点击
          loadingType: 'spinner',
          message: '搜索中...'
        });
        axios.post("/center/getmainnobilling",{
          mainNo: this.mainNo,
          communityId: this.communityId,
          location:this.location
        }).then((res)=>{
          if(res.isSuccess){
            this.ruleDetail = res.data;
            this.downRuleList = res.data.sendBillingData;
            this.upRuleList = res.data.receiveBillingData;
            Toast(res.data.isSuccess?'计费规则配置成功':'计费规则配置失败')
          }
        })
      },
      complateActive() {
        //完成激活
        axios.post("/center/complateactive",{
          mainNo: this.mainNo,
          communityId: this.communityId,
          location:this.location
        }).then((res)=>{
          if(res.isSuccess){
            Toast(res.message);
            setTimeout(()=>{
              this.$router.replace({path: "home.html"});
            },1500)
          }
        })
      },
      onClickLeft() {
        this.$router.go(-1);
      },
      onClickRight() {
        // this.$router.push({path: "search.html",query:{pageType: 3}});
      },
    },
    computed:{
    },
    created () {
      this.mainNo = this.$route.query.mainNo
      this.communityId = this.$route.query.communityId;
      this.location = this.$route.query.location;
      Toast.loading({
        duration: 10000,       // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: 'spinner',
        message: '计费规则查询中...'
      });
      setTimeout(()=>{
        this.getRuleInfo();
        this.loading = false;
      },10000)
    },
    mounted () {},
    destroyed () {}
  }
</script>
<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #F0F4F7}
  .container{
    width: 100%;height: 100%;letter-spacing:0px;background: #F0F4F7;
    padding-bottom: 100px;
  }
  .topmsg{
    width: 100%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    .van-icon{
      vertical-align: middle;
      margin: 0 10px 5px 0;
    }
  }
  .listbox{
    width: 100%;
    color: #373737;
    background: #fff;
    margin-top: 12px;
    .van-row{
      border-bottom: 1px solid #F0F4F7;
    }
    .van-col{
      font-size: 14px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .mg12{margin-top: 12px;}
  .texc{text-align: center;}
  .btnbox{
    margin-top: 50px;
    padding: 0 50px;
  }
  .loading{
    width: 100%;
    height: 100vh;
    background: #fff;
  }
</style>
